export default "__VITE_ASSET__Dxr1OMdc__"